import { OPTUM_DISCOUNT_ALIAS, isOptumFlow, type PartnerFlowInput } from './optumMode';

/** What the buy page, cart and trade-in show for a partner. One place for every Optum rule. */
export type PartnerPolicy = {
  /** UH MAX step, cart add-on, saved selection and the trade-in MAX bonus. */
  allowMax: boolean;
  /** Apple Pay skips the cart, so a cart-applied partner code would not apply. */
  allowApplePay: boolean;
  /** Tier, referral, affiliate, hero and campaign ring discounts. */
  allowRingDiscounts: boolean;
  showComparison: boolean;
  /** Heroes pill and other secondary offers under the price. */
  showSecondaryOffers: boolean;
  /** Clue add-on step on the Ring PRO buy page. */
  showClue: boolean;
  showSizingKitPopup: boolean;
  showBenefitBanner: boolean;
  /** False adds noindex (metadata + X-Robots-Tag) to the page. */
  indexable: boolean;
  /** Site header/footer, or the minimal Optum chrome (app/partner-chrome.tsx). */
  chrome: 'site' | 'optum';
  /** When set, the cart's only discount code (an alias resolved by /api/cart). */
  cartDiscountCode: string | null;
};

export const DEFAULT_PARTNER_POLICY: PartnerPolicy = {
  allowMax: true,
  allowApplePay: true,
  allowRingDiscounts: true,
  showComparison: true,
  showSecondaryOffers: true,
  showClue: true,
  showSizingKitPopup: true,
  showBenefitBanner: false,
  indexable: true,
  chrome: 'site',
  cartDiscountCode: null,
};

const OPTUM_POLICY: PartnerPolicy = {
  allowMax: false,
  allowApplePay: false,
  allowRingDiscounts: false,
  showComparison: false,
  showSecondaryOffers: false,
  showClue: false,
  showSizingKitPopup: false,
  showBenefitBanner: true,
  indexable: false,
  chrome: 'optum',
  cartDiscountCode: OPTUM_DISCOUNT_ALIAS,
};

/** The policy for a URL; PartnerModeProvider, the page and the cart all read it from here. */
export function partnerPolicyFor(input: PartnerFlowInput): PartnerPolicy {
  return isOptumFlow(input) ? OPTUM_POLICY : DEFAULT_PARTNER_POLICY;
}
